import { call, put, takeEvery } from 'redux-saga/effects'
import { types } from '../../types'
import {
    getProfile,
    resetMobileVerificatiom,
    getProvinceWithCity,
    verifyMobile, save,
    resendEmailVerfication,
    changePassword,
    addNewEmailRequest,
    changeEmailVerfication,
    rejectNewEmailRequest
}
    from '../apiRequests/profileRequest'

function* handleProfileData(action) {
    try {
        const response = yield call(getProfile, action.params)
        yield put({
            type: types.GET_PROFILE_SUCCESS,
            action: response,
        })
    } catch (error) {

        yield put({
            type: types.GET_PROFILE_ERROR,
            error: error.response,
        })
    }
}
function* handleResetMobileVerificatiom(action) {
    try {
        const response = yield call(resetMobileVerificatiom, action.params)
        yield put({
            type: types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_ERROR,
            error: error.response,
        })
    }
}
function* handleVerifyMobile(action) {
    try {
        const response = yield call(verifyMobile, action?.params)
        yield put({
            type: types.PROFILE_VERIFY_MOBILE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_VERIFY_MOBILE_ERROR,
            error: error.response,
        })
    }
}

function* handleGetProvinceWithCity(action) {
    try {
        const response = yield call(getProvinceWithCity, action.params)
        yield put({
            type: types.PROFILE_GET_PROVINCE_WITH_CITY_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_GET_PROVINCE_WITH_CITY_ERROR,
            error: error.response,
        })
    }
}

function* handleSave(action) {
    try {
        const response = yield call(save, action.params)
        yield put({
            type: types.PROFILE_SAVE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_SAVE_ERROR,
            error: error.response,
        })
    }
}

function* handleResendEmailVerfication(action) {
    try {
        const response = yield call(resendEmailVerfication, action.params)
        yield put({
            type: types.RESEND_EMAIL_VERIFICATION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.RESEND_EMAIL_VERIFICATION_ERROR,
            error: error.response,
        })
    }
}


function* handleChangePassword(action) {
    try {
        const response = yield call(changePassword, action.params)
        yield put({
            type: types.PROFILE_CHANGE_PASSWORD_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PROFILE_CHANGE_PASSWORD_ERROR,
            error: error.response,
        })
    }
}

function* handleAddNewEmail(action) {
    try {
        const response = yield call(addNewEmailRequest, action.params)
        yield put({
            type: types.ADD_NEW_EMAIL_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.ADD_NEW_EMAIL_ERROR,
            error: error.response,
        })
    }
}

function* handleChangeEmailVerfication(action) {
    try {
        const response = yield call(changeEmailVerfication, action.params)
        yield put({
            type: types.CHANGE_EMAIL_VERIFICATION_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.CHANGE_EMAIL_VERIFICATION_ERROR,
            error: error.response,
        })
    }
}

function* handleRejectNewEmail(action) {
    try {
        const response = yield call(rejectNewEmailRequest, action.params)
        yield put({
            type: types.REJECT_NEW_EMAIL_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.REJECT_NEW_EMAIL_ERROR,
            error: error.response,
        })
    }
}


function* watcherProfileSaga() {
    yield takeEvery(types.GET_PROFILE_REQUEST, handleProfileData)
    yield takeEvery(types.PROFILE_RESEND_MOBILE_VERIFICATION_CODE_REQUEST, handleResetMobileVerificatiom)
    yield takeEvery(types.PROFILE_VERIFY_MOBILE_REQUEST, handleVerifyMobile)
    yield takeEvery(types.PROFILE_GET_PROVINCE_WITH_CITY_REQUEST, handleGetProvinceWithCity)
    yield takeEvery(types.PROFILE_SAVE_REQUEST, handleSave)
    yield takeEvery(types.RESEND_EMAIL_VERIFICATION_REQUEST, handleResendEmailVerfication)
    yield takeEvery(types.CHANGE_EMAIL_VERIFICATION_REQUEST, handleChangeEmailVerfication)
    yield takeEvery(types.PROFILE_CHANGE_PASSWORD_REQUEST, handleChangePassword)
    yield takeEvery(types.ADD_NEW_EMAIL_REQUEST, handleAddNewEmail)
    yield takeEvery(types.REJECT_NEW_EMAIL_REQUEST, handleRejectNewEmail)
}

export default watcherProfileSaga
